var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w100"},[_c('card-2',{attrs:{"cardData":_vm.cardData,"moreLink":_vm.dynamicData.moreLink}}),_vm._v(" "),_c('list-public',{attrs:{"backImg":_vm.backImg,"dataList":_vm.dynamicData.list}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }